import React from 'react';
import { useParams } from 'react-router';
import {
  Highlight,
  IconBannersWarning,
  LoadingSpinner,
  VStack,
} from '@adc/parallax-component-library';
import i18n from '../../utilities/i18n';
import SensorHeader from './sensorComponents/SensorHeader';
import { useQuery } from '@tanstack/react-query';
import {
  deviceByKeyQueryOptions,
  sensorQueryOptions,
} from '../../queryOptions';
import { useErrorMessageOnEntityView } from '../../hooks/useErrorMessageOnEntityView';

/**
 * Sensor component that displays the details of a specific sensor.
 * @returns {React.JSX.Element}
 */
export default function Sensor() {
  const { sensorKey } = useParams();

  const sensor = useQuery(
    sensorQueryOptions({ key: sensorKey }, { enabled: !!sensorKey }),
  );
  const device = useQuery(
    deviceByKeyQueryOptions(sensor.data?.deviceKey || '', {
      enabled: !!sensor.data?.deviceKey,
    }),
  );

  const errorMessage = useErrorMessageOnEntityView(
    sensor.error,
    'Page_Sensor.load_error',
  );

  return (
    <VStack gap="$2" height="100%">
      {sensor.isError ? (
        <Highlight
          variant="danger"
          iconStart={
            <IconBannersWarning
              color="$neutral.0"
              accentColor="$support.danger.default"
            />
          }
          title={i18n.t('Page_Sensor.load_error_title')}
          body={errorMessage}
          testID="sensor-error-banner"
        />
      ) : null}

      {sensor.isPending || device.isPending ? (
        <VStack alignItems="center" justifyContent="center" flexGrow={1}>
          <LoadingSpinner testID="sensor-loading-spinner" />
        </VStack>
      ) : null}

      {sensor.isSuccess && device.isSuccess ? (
        <SensorHeader
          sensor={sensor.data}
          deviceId={device.data?.deviceId || ''}
        />
      ) : null}
    </VStack>
  );
}
